import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import { fetchQrRegister } from '@api/qr-code/qr-code.api';
import { ApiError } from '@lib/request';
import { ApiErrorType, QrRegisteredType } from '@typings/common';
import { FetchQrRegisterParamsDto } from '@api/qr-code/qr-code.dto';

export const fetchQrRegisterAction = createAsyncThunk<
    QrRegisteredType,
    FetchQrRegisterParamsDto,
    { rejectValue: ApiErrorType<unknown> }
>(`FETCH_QR_REGISTER`, async (payload, thunkApi) => {
    try {
        const result = await fetchQrRegister(payload);
        return result;
    } catch (error) {
        if (error instanceof ApiError) {
            return thunkApi.rejectWithValue(error.toJSON());
        }
        if (error instanceof Error) {
            throw new ApiError(error.message);
        }
        throw new ApiError();
    }
});

export const clearQrRegisterAction = createAction('CLEAR_QR_REGISTER');
